// import packages
import gql from "graphql-tag"

// export gqls
export const GET_COMPANIES = gql`
  query Companies($take: Int, $skip: Int, $input: CompanyFilterInput) {
    companies(take: $take, skip: $skip, input: $input) {
      total
      data {
        id
        name
        email
        address
        phoneNumber
        companyNumber
        area
      }
    }
  }
`
export const SUM_COMPANIES = gql`
  query Companies($input: CompanyFilterInput) {
    companies(take: 0, input: $input) {
      total
    }
  }
`

export const GET_TABLE_FIELDS = gql`
  query CompanyFields {
    companyFields @client {
      name
      title
      order
      show
    }
  }
`

export const GET_COMPANY = gql`
  query Company($id: ID!) {
    company(id: $id) {
      id
      name
      email
      address
      phoneNumber
      companyNumber
      area
    }
  }
`

export const UPDATE_COMPANY = gql`
  mutation UpdateCompany($id: ID!, $input: CompanyUpdateInput!) {
    updateCompany(id: $id, input: $input) {
      id
    }
  }
`

export const CREATE_COMPANY = gql`
  mutation CreateCompany($input: CompanyCreateInput!) {
    createCompany(input: $input) {
      id
    }
  }
`

export const DELETE_COMPANY = gql`
  mutation DeleteCompany($id: ID!) {
    deleteCompany(id: $id)
  }
`
